import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/marketing.css";
import "./sandbox/tokens/colors.scss";
import "./sandbox/tokens/tokens.scss";
import "./styles/antd-tooltip.scss";
import reportWebVitals from "./reportWebVitals";
import ProjectRoutes from "./pages";
import { BrowserRouter } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import { graphqlClient } from "./api/graphql/config";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";
import { ErrorProvider } from "./context/ErrorContext";
import ErrorMessage from "./components/ErrorMessage";
import RouteChangeNotifier from "./config/route-change-notifier";
import { BugsnagErrorBoundary } from "./config/bugsnag";
import { initAnalytics } from "./config/analytics";
import CookieConsentBanner from "./components/CookieConsentBanner";
import { captureInstallPrompt } from "./utils/installPrompt";

initAnalytics();
captureInstallPrompt();

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ApolloProvider client={graphqlClient}>
      <BrowserRouter>
        <ErrorProvider>
          <BugsnagErrorBoundary>
            <ErrorMessage />
            <RouteChangeNotifier />
            <CookieConsentBanner />
            <ProjectRoutes />
          </BugsnagErrorBoundary>
        </ErrorProvider>
      </BrowserRouter>
    </ApolloProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
